export type VoltageProtectionLimits = {
	undervoltage: { min: number; max: number };
	overvoltage: { min: number; max: number };
};

export const UNDERVOLTAGE_MIN_FW = '0.13.0';

export const DEFAULT_VOLTAGE_THR = 5;
export const MIN_VOLTAGE_THR = 5;
export const MAX_VOLTAGE_THR = 10;

export const DEFAULT_AUTORECOVERY_DELAY = 1;
export const MIN_AUTORECOVERY_DELAY = 1;
export const MAX_AUTORECOVERY_DELAY = 60;
